import { render, staticRenderFns } from "./VersionPushModal.vue?vue&type=template&id=700a56e6"
import script from "./VersionPushModal.vue?vue&type=script&lang=js"
export * from "./VersionPushModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports